module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTkyOCAzMjBhMzIgMzIgMCAwIDEgMzIgMzJ2MzIwYTMyIDMyIDAgMCAxLTI4LjMgMzEuOEw5MjggNzA0SDk2YTMyIDMyIDAgMCAxLTMyLTMyVjM1MmEzMiAzMiAwIDAgMSAzMi0zMmg4MzJ6IG0tMzIgNjRIMTI4djI1Nmg5NnYtMTYwYTMyIDMyIDAgMCAxIDY0IDB2MTYwaDk2di05NmEzMiAzMiAwIDAgMSA2NCAwdjk2aDEyOHYtOTZhMzIgMzIgMCAwIDEgNjQgMHY5Nmg5NnYtMTYwYTMyIDMyIDAgMCAxIDY0IDB2MTYwaDk2di0yNTZ6IiBmaWxsPSIjMCIgcC1pZD0iMjI0OCI+PC9wYXRoPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Ruler-outlined.svg
// module id = HrTY
// module chunks = 74